// extracted by mini-css-extract-plugin
export var mainHeader = "main-header_HClGZ8PgcbPt4pNEF7UB";
export var mainHeaderCaption = "main-header__caption_AmG_WH36Z89ve66AndNi";
export var mainHeaderSearchBlock = "main-header__search-block_G9vG9ZZ7uLU3LRe3kkSX";